import React, { useEffect, useState } from 'react';
import { Container, Row, Col, FormInput, FormGroup, Form, Button, FormSelect, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import Input from '../../../components/UI/Input/Input';
import Select from '../../../components/UI/Select/Select';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import LinearProgress from '@material-ui/core/LinearProgress';

const UpdateOpuUser = () => {
  const { submitHandler, back, loading, field } = useForm();
  const { t, i18n } = useTranslation();
  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('opu-user.title.update')} subtitle={t('opu-user.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4 py-5 px-4">
              {' '}
              <form>
                <Row>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.firstName')}
                      label={t('label.firstName')}
                      {...field('firstName')}
                    />
                  </Col>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.lastName')}
                      label={t('label.lastName')}
                      {...field('lastName')}
                    />
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.gender')} label={t('label.gender')} {...field('gender')}>
                      <option value="" disabled selected>
                        {t('gender')}
                      </option>
                      <option value="F">{t('female')}</option>
                      <option value="M">{t('male')}</option>
                    </Select>
                  </Col>
                  <Col md="6">
                    <Input type="email" placeholder={t('placeholder.email')} label={t('label.email')} {...field('email')} />
                  </Col>
                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.phone')} label={t('label.phone')} {...field('phone')} />
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.role')} label={t('label.role')} {...field('role')}>
                      <option value="" disabled selected>
                        {t('role')}
                      </option>
                      <option value="super_admin">{t('super_admin')}</option>
                      <option value="admin">{t('admin')}</option>
                      <option value="commercial_admin">{t('commercial_admin')}</option>
                    </Select>
                  </Col>

                  <Col md="12" className="d-flex justify-content-end">
                    <Button theme="info" disabled={loading} onClick={() => back()}>
                      {t('annuler')}
                    </Button>
                    &nbsp; &nbsp;
                    <Button theme="success" type="button" disabled={loading} onClick={() => submitHandler()}>
                      {t('update')}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UpdateOpuUser;
